(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["after-before-image-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".ba-slider");
  const before = slider.querySelector(".ba-before");
  const handle = slider.querySelector(".ba-handle");

  let isDragging = false;

  function moveSlider(clientX) {

    const rect = slider.getBoundingClientRect();

    let position = ((clientX - rect.left) / rect.width) * 100;

    // Keep slider between 0% and 100%
    position = Math.max(0, Math.min(100, position));

    before.style.width = position + "%";
    handle.style.left = position + "%";
  }

  /* MOUSE */
  handle.addEventListener("mousedown", function (e) {
    e.preventDefault();
    isDragging = true;
  });

  document.addEventListener("mousemove", function (e) {
    if (!isDragging) return;

    moveSlider(e.clientX);
  });

  document.addEventListener("mouseup", function () {
    isDragging = false;
  });


  /* TOUCH */
  handle.addEventListener("touchstart", function (e) {
    isDragging = true;
  }, { passive: true });

  document.addEventListener("touchmove", function (e) {

    if (!isDragging) return;

    moveSlider(e.touches[0].clientX);

  }, { passive: true });

  document.addEventListener("touchend", function () {
    isDragging = false;
  });


  /* CLICK ANYWHERE ON SLIDER */
  slider.addEventListener("click", function (e) {

    if (e.target === handle || handle.contains(e.target)) {
      return;
    }

    moveSlider(e.clientX);

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-review"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  const reviewsSwiper = new Swiper(".reviewsSwiper", {

    slidesPerView: 3,
    spaceBetween: 32,
    loop: true,
    speed: 700,

    navigation: {
      nextEl: ".review-next",
      prevEl: ".review-prev",
    },

    pagination: {
      el: ".review-pagination",
      clickable: true,
    },

    breakpoints: {

      0: {
        slidesPerView: 1.20,
        spaceBetween: 15,
        centeredSlides: true,
      },

      576: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        centeredSlides: true,
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 24
      },

      1024: {
        slidesPerView: 3,
        spaceBetween: 32
      }

    }

  });

});


document.addEventListener('DOMContentLoaded', function () {

  function addReviewerInfo() {

    const reviews = document.querySelectorAll(
      '.jdgm-carousel-item, .jdgm-carousel__item'
    );

    reviews.forEach(function (review) {

      /* Already added */
      if (review.querySelector('.custom-reviewer-info')) {
        return;
      }

      /* Author name */
      const author =
        review.querySelector('.jdgm-rev__author') ||
        review.querySelector('.jdgm-carousel-item__reviewer-name') ||
        review.querySelector('.jdgm-rev__author-wrapper');

      /* Date */
      const date =
        review.querySelector('.jdgm-rev__timestamp') ||
        review.querySelector('.jdgm-carousel-item__reviewer-date');

      if (!author && !date) {
        return;
      }

      /* Author image */
      const existingImage =
        review.querySelector('.jdgm-rev__author-avatar') ||
        review.querySelector('.jdgm-author-avatar') ||
        review.querySelector('.jdgm-rev__author-image');

      const wrapper = document.createElement('div');
      wrapper.className = 'custom-reviewer-info';

      /* Avatar */
      const avatar = document.createElement('div');
      avatar.className = 'custom-reviewer-avatar';

      if (existingImage) {

        const img = existingImage.querySelector('img');

        if (img) {
          avatar.innerHTML = `
            <img
              src="${img.src}"
              alt="${author ? author.textContent.trim() : 'Reviewer'}"
            >
          `;
        } else {
          avatar.innerHTML = `
            <div class="custom-avatar-placeholder">
              ${author ? author.textContent.trim().charAt(0).toUpperCase() : 'U'}
            </div>
          `;
        }

      } else {

        avatar.innerHTML = `
          <div class="custom-avatar-placeholder">
            ${author ? author.textContent.trim().charAt(0).toUpperCase() : 'U'}
          </div>
        `;

      }

      /* Author details */
      const details = document.createElement('div');
      details.className = 'custom-reviewer-details';

      if (author) {
        const name = document.createElement('div');
        name.className = 'custom-reviewer-name';
        name.textContent = author.textContent.trim();

        details.appendChild(name);
      }

      if (date) {
        const reviewDate = document.createElement('div');
        reviewDate.className = 'custom-reviewer-date';
        reviewDate.textContent = date.textContent.trim();

        details.appendChild(reviewDate);
      }

      wrapper.appendChild(avatar);
      wrapper.appendChild(details);

      /* Insert before review title/body */
      const title =
        review.querySelector('.jdgm-rev__title') ||
        review.querySelector('.jdgm-carousel-item__review-title');

      if (title) {
        title.parentNode.insertBefore(wrapper, title);
      } else {
        review.appendChild(wrapper);
      }

    });
  }

  /* Judge.me loads asynchronously */
  addReviewerInfo();

  const observer = new MutationObserver(function () {
    addReviewerInfo();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-befor-after"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".before-after-section");

  sections.forEach(function(section) {

    const container = section.querySelector(".before-after");
    const clip = section.querySelector(".before-after__clip");
    const slider = section.querySelector(".before-after__slider");
    const range = section.querySelector(".before-after__range");

    if (!container || !clip || !slider || !range) return;


    function updateSlider(value) {

      value = Math.max(0, Math.min(100, value));

      clip.style.width = value + "%";
      slider.style.left = value + "%";

    }


    /*
     * Keep the BEFORE image exactly aligned
     * with the AFTER image.
     */
    function syncBeforeImage() {

      const containerWidth = container.offsetWidth;

      const beforeImages = clip.querySelectorAll(
        ".before-after__image--before"
      );

      beforeImages.forEach(function(beforeImage) {
        beforeImage.style.width = containerWidth + "px";
      });

    }


    /* Keyboard / accessibility control */
    range.addEventListener("input", function () {
      updateSlider(this.value);
    });


    /* Move the divider to a screen position */
    function setFromX(clientX) {

      const rect = container.getBoundingClientRect();

      let percentage = ((clientX - rect.left) / rect.width) * 100;

      percentage = Math.max(0, Math.min(100, percentage));

      range.value = percentage;

      updateSlider(percentage);
    }


    /*
     * Dragging (mouse + touch).
     * Sideways drags move the divider; vertical swipes scroll the page.
     * The CSS "touch-action: pan-y" lets the browser scroll vertically,
     * and the browser sends "pointercancel" when it takes over to scroll.
     */
    const THRESHOLD = 8; // pixels of movement before deciding the direction

    let active = false;   // finger or mouse is down on the slider
    let dragging = false; // confirmed sideways drag
    let startX = 0;
    let startY = 0;


    container.addEventListener("pointerdown", function (event) {

      if (event.pointerType === "mouse" && event.button !== 0) return;

      active = true;
      dragging = false;
      startX = event.clientX;
      startY = event.clientY;

      if (event.pointerType === "mouse") {
        // Mouse: drag right away and keep tracking outside the slider
        dragging = true;
        container.setPointerCapture(event.pointerId);
        setFromX(event.clientX);
        event.preventDefault();
      }
    });


    container.addEventListener("pointermove", function (event) {

      if (!active) return;

      if (!dragging) {

        const dx = Math.abs(event.clientX - startX);
        const dy = Math.abs(event.clientY - startY);

        if (dx < THRESHOLD && dy < THRESHOLD) return; // too small to tell yet

        if (dy > dx) {
          // Vertical swipe: leave it to the page
          active = false;
          return;
        }

        dragging = true;
      }

      setFromX(event.clientX);
    });


    container.addEventListener("pointerup", function (event) {

      // A tap (no real movement) jumps the divider to that spot
      if (active && !dragging) {
        setFromX(event.clientX);
      }

      active = false;
      dragging = false;
    });


    container.addEventListener("pointercancel", function () {

      // The browser took over to scroll the page
      active = false;
      dragging = false;
    });


    /*
     * Initial setup
     */
    function init() {

      syncBeforeImage();

      updateSlider(range.value);

    }


    window.addEventListener(
      "resize",
      syncBeforeImage
    );


    /*
     * Wait for images to load
     */
    const images = container.querySelectorAll("img");

    let loaded = 0;

    if (images.length === 0) {
      init();
      return;
    }

    images.forEach(function (img) {

      if (img.complete) {

        loaded++;

        if (loaded === images.length) {
          init();
        }

      } else {

        img.addEventListener("load", function () {

          loaded++;

          if (loaded === images.length) {
            init();
          }

        });

      }

    });


    setTimeout(init, 300);

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-accordian-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  function initProAccordion() {

    const sections = document.querySelectorAll(
      ".pro-accordian-list"
    );

    sections.forEach(function (section) {

      const faqItems = section.querySelectorAll(
        ".pro-faq-item"
      );

      faqItems.forEach(function (item) {

        const button = item.querySelector(
          ".pro-faq-question"
        );

        const answer = item.querySelector(
          ".pro-faq-answer"
        );

        if (!button || !answer) return;

        button.addEventListener("click", function () {

          const isOpen = item.classList.contains(
            "active"
          );

          /* Close all other FAQs */
          faqItems.forEach(function (otherItem) {

            if (otherItem !== item) {

              otherItem.classList.remove(
                "active"
              );

              const otherAnswer =
                otherItem.querySelector(
                  ".pro-faq-answer"
                );

              const otherButton =
                otherItem.querySelector(
                  ".pro-faq-question"
                );

              if (otherAnswer) {
                otherAnswer.style.maxHeight = null;
              }

              if (otherButton) {
                otherButton.setAttribute(
                  "aria-expanded",
                  "false"
                );
              }

            }

          });

          /* Toggle current FAQ */
          if (!isOpen) {

            item.classList.add("active");

            answer.style.maxHeight =
              answer.scrollHeight + "px";

            button.setAttribute(
              "aria-expanded",
              "true"
            );

          } else {

            item.classList.remove("active");

            answer.style.maxHeight = null;

            button.setAttribute(
              "aria-expanded",
              "false"
            );

          }

        });

      });

    });

  }

  initProAccordion();

  /* Shopify Theme Editor support */
  document.addEventListener(
    "shopify:section:load",
    function () {
      initProAccordion();
    }
  );

});

  } catch(e) { console.error(e); }
})();
})();
